export default {
  title: 'Produse',
};
